import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="pt-24 pb-16 bg-growlyy-gray-light">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
          <Link to="/" className="inline-flex items-center text-growlyy-primary mb-6 hover:text-growlyy-secondary transition-colors">
            <FaArrowLeft className="mr-2" /> Retour à l'accueil
          </Link>
          
          <h1 className="text-3xl md:text-4xl font-bold text-growlyy-primary mb-8">POLITIQUE DE CONFIDENTIALITÉ</h1>
          
          <div className="space-y-8">
            <section>
              <h2 className="text-xl font-semibold text-growlyy-primary mb-4">1. Collecte des données personnelles</h2>
              <p className="text-growlyy-gray-dark">
                Growlyy collecte et traite des données personnelles afin d'améliorer ses services. 
                Les données collectées incluent les informations de contact, les interactions avec 
                la plateforme et les préférences des utilisateurs.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-growlyy-primary mb-4">2. Utilisation des données</h2>
              <p className="text-growlyy-gray-dark mb-4">
                Les données collectées sont utilisées pour :
              </p>
              <ul className="list-disc pl-6 space-y-2 text-growlyy-gray-dark">
                <li>Personnaliser les services et améliorer l'expérience utilisateur</li>
                <li>Envoyer des communications marketing avec le consentement de l'utilisateur</li>
                <li>Assurer la sécurité et la conformité de la plateforme</li>
                <li>Exécuter les campagnes de prospection en conformité avec les instructions des clients</li>
              </ul>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-growlyy-primary mb-4">3. Partage des données</h2>
              <p className="text-growlyy-gray-dark">
                Les données peuvent être partagées avec des prestataires tiers pour l'exécution du service 
                (hébergement, paiement, analytics). Growlyy ne vend ni ne loue les données personnelles à des tiers.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-growlyy-primary mb-4">4. Sécurité des données</h2>
              <p className="text-growlyy-gray-dark">
                Growlyy met en place des mesures de sécurité techniques et organisationnelles pour protéger 
                les données contre les accès non autorisés, les pertes ou les altérations.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-growlyy-primary mb-4">5. Droits des utilisateurs</h2>
              <p className="text-growlyy-gray-dark mb-4">
                Conformément au RGPD, les utilisateurs disposent des droits suivants :
              </p>
              <ul className="list-disc pl-6 space-y-2 text-growlyy-gray-dark">
                <li>Accès, rectification et suppression de leurs données personnelles</li>
                <li>Opposition au traitement et portabilité des données</li>
                <li>Réclamation auprès de la CNIL en cas de non-respect de ces droits</li>
              </ul>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-growlyy-primary mb-4">6. Contact</h2>
              <p className="text-growlyy-gray-dark">
                Pour toute demande relative à la protection des données, vous pouvez nous contacter à :
                <a href="mailto:contact@growlyy.fr" className="text-growlyy-secondary hover:underline ml-1">
                  contact@growlyy.fr
                </a>.
              </p>
            </section>
          </div>
          
          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-growlyy-gray-dark text-sm">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 